import { PlanMarket } from '@zorro/clients';
import { $enum } from 'ts-enum-util';

export enum DisplayPlanMarket {
  OFF_EXCHANGE = 'OFF_EXCHANGE',
  ON_EXCHANGE = 'ON_EXCHANGE',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
}

export const mapDisplayToPlanMarket = (
  displayPlanMarket: DisplayPlanMarket | null
): PlanMarket | null => {
  if (
    !displayPlanMarket ||
    !Object.values(DisplayPlanMarket).includes(displayPlanMarket)
  ) {
    return null;
  }

  return $enum.mapValue(displayPlanMarket).with<PlanMarket | null>({
    [DisplayPlanMarket.OFF_EXCHANGE]: PlanMarket.OFF_EXCHANGE,
    [DisplayPlanMarket.ON_EXCHANGE]: PlanMarket.ON_EXCHANGE,
    [DisplayPlanMarket.NOT_APPLICABLE]: null,
  });
};

export const mapPlanMarketToDisplay = (
  planMarket?: PlanMarket | null
): DisplayPlanMarket | null => {
  if (!planMarket || !Object.values(PlanMarket).includes(planMarket)) {
    return null;
  }

  return $enum.mapValue(planMarket).with<DisplayPlanMarket | null>({
    [PlanMarket.OFF_EXCHANGE]: DisplayPlanMarket.OFF_EXCHANGE,
    [PlanMarket.ON_EXCHANGE]: DisplayPlanMarket.ON_EXCHANGE,
    [PlanMarket.BOTH_MARKETS]: null,
  });
};
